import { brandApi } from "@/lib/axios";

export interface KlaviyoStatus {
  connected: boolean;
  status: "ACTIVE" | "NEEDS_RECONNECT" | "DISCONNECTED" | null;
  accountId: string | null;
  accountName: string | null;
}

export async function getKlaviyoStatus(): Promise<KlaviyoStatus> {
  const { data } = await brandApi.get<KlaviyoStatus>("/klaviyo/status");
  return data;
}

/** The Klaviyo install URL; send the browser there to start connecting. */
export async function getKlaviyoOauthUrl(): Promise<{ url: string }> {
  const { data } = await brandApi.get<{ url: string }>("/klaviyo/oauth/url");
  return data;
}

export async function disconnectKlaviyo(): Promise<{ disconnected: boolean }> {
  const { data } = await brandApi.delete<{ disconnected: boolean }>("/klaviyo/connection");
  return data;
}
